import { Suspense, lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { oauthTranslations as enOauth } from '@/lang/en/oauth';
import { oauthTranslations as esOauth } from '@/lang/es/oauth';
import { oauthTranslations as ptOauth } from '@/lang/pt/oauth';
import type { FeatureModule } from '@/platform/app/contracts';
import { namespaceBundle } from '@/platform/i18n/types';

const OAuthNavigation = lazy(() =>
  import('./OAuthNavigation').then((m) => ({ default: m.OAuthNavigation })),
);

/** MCP OAuth consent screen translations. */
export const oauthModule: FeatureModule = {
  id: 'oauth',
  i18n: namespaceBundle('oauth', { es: esOauth, en: enOauth, pt: ptOauth }),
};

/** `/oauth/*` lives outside the authenticated shell (it gates on the session itself). */
export const oauthRoutes: RouteObject[] = [
  {
    path: '/oauth/*',
    element: (
      <Suspense fallback={null}>
        <OAuthNavigation />
      </Suspense>
    ),
  },
];
